import request from '../../constants/fetch';
import queryString from 'query-string';
import pickBy from 'lodash/pickBy';

/**
 * API login with email and password
 * @param data
 * @returns {Promise<unknown>}
 */
export const loginWithFormService = (data) => request.post('/auth/local/signin', data);

/**
 * API refresh token
 * @returns {Promise<unknown>}
 */
 export const refreshTokenService = () => request.post('/auth/refresh', {}, 'POST', 'refresh');